import React, { useCallback, useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import InputTextField from "../../../components/input/inputTextField";
import InputDatePicker from "../../../components/input/inputDatePicker";
import moment from "moment";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useTranslation } from "react-i18next";
import { RemoveRedEyeOutlined, SearchOutlined } from "@mui/icons-material";
import DropdownButton from "../../../components/button/DropdownButton";
import { loginLogApi } from "../../../api/login-log/login-log.api";
import { dateToView, timeToView } from "../../../utils/date.utils";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import InputNewRangePicker from "../../../components/input/inputRankPicker";
import { debouncedApiCall } from "../../../utils/app.utils";
import { ReportApi } from "../../../api/report/Report.api";
import { saveAs } from "file-saver";
import {
  getFileExtension,
} from "../../../utils/fileTypeDownload";

type Props = {};

const LoginLogOutHistory: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [loginHistory, setDataLoginHistory] = useState<any[]>([]);
  const [search, setSearch] = useState<string>("created_date");

  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);
  const handleRangeDate = (value: any) => {
    setSelectedDateRange(value);
    setStartDate(moment(value[0]).format("YYYY-MM-DD"));
    setEndDate(moment(value[1]).format("YYYY-MM-DD"));
  };
  const handleClearRangeDate = () => {
    setSelectedDateRange([]);
    setStartDate("");
    setEndDate("");
  };

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(10);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("DESC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const headCells = [
    {
      id: "123",
      width: 2,
      disablePadding: false,
      align: "center",
      label: "#",
    },
    {
      id: "fullname",
      width: 50,
      disablePadding: false,
      align: "start",
      label: "ชื่อ-นามสกุล",
    },
    {
      id: "nickname",
      disablePadding: false,
      width: 75,
      align: "center",
      label: "ฉายา",
    },
    {
      id: "type",
      disablePadding: false,
      align: "center",
      width: 25,
      label: "ประเภท",
    },
    {
      id: "date",
      disablePadding: false,
      align: "center",
      width: 40,
      label: "วันที่",
    },
    {
      id: "time",
      disablePadding: false,
      align: "center",
      width: 75,
      label: "เวลา",
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_employee,
      title,
      first_name,
      last_name,
      buddhist_name,
      created_date,
      action,
    } = objData;

    const objRenderData = {
      key: no,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: `${no}` || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: `${title} ${first_name} ${last_name}` || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: buddhist_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: action || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: created_date ? dateToView(created_date) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: created_date ? timeToView(created_date) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <RemoveRedEyeOutlined
              onClick={() => {
                navigate(
                  routeName.cms.PersonnelManagement +
                  `-detail/view/${id_employee}`
                );
              }}
              style={{
                cursor: "pointer",
              }}
            />
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  const fetchGetLogInHistory = useCallback(async () => {
    let query: { page: number, limit: number, sortBy: string, sortType: string, search?: string, sdate?: string, edate?: string } = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
    };
    if (search) query.search = search
    if (startDate) query.sdate = startDate;
    if (endDate) query.edate = endDate;
    dispatch(setLoading());
    await loginLogApi.getLoginHistory(query).then((res) => {
      if (res.status < 300) {
        const response = res.data?.data || [];
        setDataLoginHistory(response?.items || []);
        setTotalItems(response?.meta?.totalItems || 0);
      }
    }).catch((err) => {
      console.log(err);
    }).finally(() => {
      dispatch(unsetLoading());
    })
  }, [page, pageLimit, sortBy, sortType, startDate, endDate, search])

  useEffect(() => {
    fetchGetLogInHistory();
  }, [fetchGetLogInHistory]);

  const handleDownloadFile = async (export_type: string) => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      search: search,
      sdate: startDate,
      edate: endDate,
      type: export_type,
    };
    dispatch(setLoading());
    await ReportApi.GetLoginLogoutLog(query)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          // Generate a filename with the correct extension (you can also modify this to use a custom name)
          const fileName = `log-login-logout-${new Date().getTime()}.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };


  return (
    <div>
      <ContentHeading
        title={"ประวัติการ login - logout บุคลากร"}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />

      <div
        className="w-full mt-[40px]"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", gap: "16px" }}>
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหาชื่อ - นามสกุล/ชื่อฉายา"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />

          <InputNewRangePicker
            value={selectedDateRange}
            onchange={handleRangeDate}
            onClear={handleClearRangeDate}
            allowClear
          />
        </div>

        <div>
          <DropdownButton
            buttonName={t("BUTTON.DOWNLOAD_FILE")}
            menuItems={[
              {
                id: 1,
                name: "pdf",
                onClick: () => {
                  handleDownloadFile("pdf");
                },
              },
              {
                id: 2,
                name: "excel",
                onClick: () => {
                  handleDownloadFile("xlsx");
                },
              },
            ]}
            fullWidth={true}
          />
        </div>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={loginHistory?.map((data: any, i: number) => {
            return renderData(data, i);
          })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default LoginLogOutHistory;
